// // The real breakAiRecommendations data (from getLocalizedRecommendationsData()) never
// // includes Offerings — the backend has no concept of a Seller's menu. For this PoC, the same
// // 7 Offerings are hardcoded here and reused for every Seller, per the finalized flow spec.

import carneDeAsada from '@/assets/images/poc/carne-de-asada.png';
import menudoLarge from '@/assets/images/poc/menudo-large.png';
import grilledChickenBucheAsadaTacos from '@/assets/images/poc/grilled-chicken-buche-asada-tacos.png';
import mexicanFlan from '@/assets/images/poc/mexican-flan.png';
import chorizoTaco from '@/assets/images/poc/chorizo-taco.png';
import grilledChickenTaco from '@/assets/images/poc/grilled-chicken-taco.png';
import mixedFajitas from '@/assets/images/poc/mixed-fajitas.png';
import logoDoorDash from '@/assets/images/poc/logo-doordash.png';

// // Partner Service Platform — hardcoded to DoorDash for this PoC.
export const pickSellerAndOfferingsPsp = {
  pspTitle: 'DoorDash',
  pspLogo: logoDoorDash,
};

// // No real fee-calculation source for this PoC — flat hardcoded amounts.
export const pickSellerAndOfferingsFees = {
  taxAmount: 2.79,
  deliveryFeeAmount: 4.99,
  serviceFeeAmount: 5.49,
};

export const pickSellerAndOfferingsOfferings = [
  {
    offeringUuid: 'offering-carne-de-asada',
    offeringTitle: 'Carne De Asada',
    offeringDescription: 'Flank steak marinated in citrus and spices',
    offeringPrice: '$18.50',
    offeringImage: carneDeAsada,
  },
  {
    offeringUuid: 'offering-menudo-large',
    offeringTitle: 'Menudo Large',
    offeringDescription: 'Weekends only',
    offeringPrice: '$16.99',
    offeringImage: menudoLarge,
  },
  {
    offeringUuid: 'offering-grilled-chicken-buche-asada-tacos',
    offeringTitle: 'Grilled Chicken, Buche Asada Tacos',
    offeringDescription: 'Regular taco with meat, cilantro, onions, and salsa',
    offeringPrice: '$11.99',
    offeringImage: grilledChickenBucheAsadaTacos,
  },
  {
    offeringUuid: 'offering-mexican-flan',
    offeringTitle: 'Mexican Flan',
    offeringDescription: 'Creamy caramel topped dessert',
    offeringPrice: '$5.25',
    offeringImage: mexicanFlan,
  },
  {
    offeringUuid: 'offering-chorizo-taco',
    offeringTitle: 'Chorizo Taco',
    offeringDescription: 'Regular taco with meat, cilantro, onions, and salsa',
    offeringPrice: '$11.99',
    offeringImage: chorizoTaco,
  },
  {
    offeringUuid: 'offering-grilled-chicken-taco',
    offeringTitle: 'Grilled Chicken Taco',
    offeringDescription: 'Regular taco with meat, cilantro, onions, and salsa',
    offeringPrice: '$11.99',
    offeringImage: grilledChickenTaco,
  },
  {
    offeringUuid: 'offering-mixed-fajitas',
    offeringTitle: 'Mixed Fajitas',
    offeringDescription:
      'Shrimp, chicken, and asada, lettuce, sour cream, guacamole, shredded cheese, and tomatoes',
    offeringPrice: '$21.85',
    offeringImage: mixedFajitas,
  },
];

export default pickSellerAndOfferingsOfferings;
